import * as React from 'react';
import './clickable-overlay.less';

const ClickableOverlay = ( props ) => (
    <div className="clickable-overlay-container" id={ props.id }>
        <div
            className="clickable-overlay-close"
            id="clickableOverlayClose"
            onClick={ props.onClick }
        />
        { props.children }
    </div>
);

export default ClickableOverlay;
